import React from "react";
import { Link, useParams } from "react-router-dom";
import Title from "components/Shared/Title";
import IconButton from "components/Shared/IconButton";
import Plus from "icons/Plus";

const PostCreateProductPage = (): React.ReactElement => {
  const { productId } = useParams();

  return (
    <div
      className="w-full h-full flex flex-col items-center justify-center bg-white rounded-lg p-4 lg:p-10 mobile-full-screen"
      data-testid="noItems">
      <img src="/images/svg/deliver.svg" />
      <Title className="pt-10 pb-3 text-center">Products successfully added</Title>
      <p className="text-grey-50 px-4 text-center">
        Allocate store items usage measurement to your product variants
      </p>
      <Link to={`/products/${productId}/configure`} data-testid="" className="mt-8">
        <IconButton icon={<Plus />}>Setup product configuration</IconButton>
      </Link>
      <Link to={`/products/${productId}`} data-testid="" className="mt-4 link">
        I’ll do this later
      </Link>
    </div>
  );
};

export default PostCreateProductPage;
